import ddt from '@wix/da-ddt';
import { isSSR, toJsonString } from './utils';
import { AdProviders, ADUNIT_IDS, FREESTAR_PREFIX } from './constants';
import Gak from './providers/Gak';
import Primis from './providers/Primis';
import Freestar from './providers/Freestar';
class DaAds {
    // Special init for SSR where we noop the client only parts
    initSSR(providers) {
        this.init(providers, []);
        return this;
    }
    // Init for the client
    init(providers, activeUnits) {
        ddt.log('ads', 'Init', providers);
        this.activeUnits = activeUnits;
        for (const provider of providers){
            const inst = this.factoryProvider(provider);
            if (inst) {
                inst.init();
                this.activeProviders[provider] = inst;
            }
        }
        this.providersReady = true;
        if (this.registerQueue.length > 0) {
            ddt.log('ads', 'Process Queue');
            this.registerQueue.map((q)=>q());
            this.registerQueue = [];
            // Init queued bi context
            if (this.biContext) {
                for (const key of Object.keys(this.activeProviders)){
                    this.activeProviders[key].setBiContext(this.biContext, this.publicSession);
                }
            }
        }
    }
    registerUnit(provider, unitId, safety, options) {
        // Skip already registered units that have same safety level, happens a lot because SSR
        if (this.activeUnits.includes(this.getAdunitIdent(unitId, safety)) || isSSR() && options.clientOnly === true) {
            ddt.log('ads', 'Skip ads', provider, unitId, options);
            return;
        }
        ddt.log('ads', 'Register Unit', provider, unitId, options, this);
        if (!this.providersReady) {
            ddt.log('ads', 'Queuing register request', provider, unitId, options);
            let resolve;
            const promisedRegister = new Promise((r)=>{
                resolve = ()=>{
                    r(this.registerUnit(provider, unitId, safety, options));
                };
            });
            this.registerQueue.push(resolve);
            return promisedRegister;
        }
        if (!this.activeProviders[provider]) {
            ddt.alert('ads', 'Tried to register ad for inactive provider', [
                'ads'
            ], {
                unitId,
                safety,
                provider,
                options
            });
            return;
        }
        if (!unitId || !ADUNIT_IDS.includes(unitId.replace(FREESTAR_PREFIX, '')) && !(unitId === null || unitId === void 0 ? void 0 : unitId.includes('-dyn-'))) {
            ddt.alert('ads', 'Tried to register unknown adunit', [
                'ads'
            ], {
                provider,
                unitId,
                options
            });
            return;
        }
        try {
            this.activeProviders[provider].registerUnit(unitId, options, safety);
            this.activeUnits.push(this.getAdunitIdent(unitId, safety));
        } catch (e) {
            ddt.alertOnError(e, 'ads', 'Error from unit registration', [
                'ads'
            ], {
                provider,
                unitId,
                options
            });
        }
    }
    killUnit(unitId, safety) {
        for (const key of Object.keys(this.activeProviders)){
            this.activeProviders[key].killUnit(unitId);
        }
        this.activeUnits = this.activeUnits.filter((u)=>u !== this.getAdunitIdent(unitId, safety));
    }
    getSSRAdUnits() {
        let output = `window.__ADUNITS__ = JSON.parse(${toJsonString(this.activeUnits)});\nwindow.__ADPROV__ = JSON.parse(${toJsonString(Object.keys(this.activeProviders))});\n`;
        for (const key of Object.keys(this.activeProviders)){
            if (this.activeProviders[key].toSSR) {
                output = `${output}${this.activeProviders[key].toSSR()}`;
            }
        }
        return output;
    }
    setBiContext(context, session) {
        if (!this.providersReady) {
            this.biContext = context;
            this.publicSession = session;
            return;
        }
        for (const key of Object.keys(this.activeProviders)){
            this.activeProviders[key].setBiContext(context, session);
        }
    }
    factoryProvider(provider) {
        switch(provider){
            case AdProviders.Gak:
                return new Gak();
            case AdProviders.Primis:
                return new Primis();
            case AdProviders.Freestar:
                return new Freestar();
            default:
                ddt.alert('ads', 'Tried to init bad provider', [
                    'ads'
                ], provider);
                return false;
        }
    }
    getAdunitIdent(unitId, safety) {
        return `${unitId}-${safety}`;
    }
    constructor(){
        this.activeProviders = {};
        this.activeUnits = [];
        this.providersReady = false;
        this.registerQueue = [];
    }
}
export default DaAds;
